import { formatDateWithLocale, getPeriodTypeNameWithLocale, getDayOfWeekName } from './date';
import { formatNumberWithLocale } from './number';
import { defaultLocale } from './locale';
import { PeriodType, DayOfWeek } from './date_types';
export function format(value, format, options) {
    return formatWithLocale(defaultLocale, value, format, options);
}
export function formatWithLocale(settings, value, format, options) {
    let formattedValue;
    if (format) {
        if (typeof format === 'function') {
            formattedValue = format(value);
        }
        else if (format in PeriodType) {
            formattedValue = formatDateWithLocale(settings, value, format, options);
        }
        else if (typeof value === 'number') {
            formattedValue = formatNumberWithLocale(settings, value, format, options);
        }
    }
    return formattedValue ?? ''; // return empty string so Svelte doesn't render `null` string;
}
export function buildFormatters(settings) {
    const mainFormat = (value, style, options) => formatWithLocale(settings, value, style, options);
    mainFormat.settings = settings;
    mainFormat.getDayOfWeekName = (day) => getDayOfWeekName(day, settings.locale);
    mainFormat.getPeriodTypeName = (period) => getPeriodTypeNameWithLocale(settings, period);
    return mainFormat;
}
